import { useMemo } from 'react';
import { useTheme } from '@mui/material/styles';
import {
  Label,
  Node,
  Tooltip,
  TooltipDetails,
} from '@/pages/Candidate/view/utils/DecisionTreeDiagram/nodes/TooltipNode/styled';
import { getNodeStyles } from '@/pages/Candidate/view/utils/DecisionTreeDiagram/nodes/TooltipNode/utils';
import { TooltipNodeProps } from '@/pages/Candidate/view/utils/DecisionTreeDiagram/nodes/TooltipNode/types';

const TooltipNode = ({ data, styles }: TooltipNodeProps) => {
  const theme = useTheme();
  const { label, tooltipProps, value } = data || {};
  const { listLabel = [], label: stringLabel, position } = tooltipProps || {};

  const nodeStyle = useMemo(() => getNodeStyles(value, theme), [value, theme]);

  return (
    <Node style={{ ...nodeStyle, ...styles }}>
      <Label>{label}</Label>
      {(stringLabel || listLabel.length > 0) && (
        <Tooltip className="tooltip" position={position}>
          {stringLabel}
          {listLabel && (
            <TooltipDetails>
              {listLabel.map((label: string, idx: number) => (
                <p key={`${idx}-${label}`}>{label}</p>
              ))}
            </TooltipDetails>
          )}
        </Tooltip>
      )}
    </Node>
  );
};

export default TooltipNode;
